import { call, put, select, takeEvery } from "redux-saga/effects";
import { patchAccountDetails } from "../../api/SessionServiceManager";
import { types, updateWidgetConfig } from "../actions";

const activeSession = (state) => state.sessionReducer.activeSession;

function* WidgetSaga() {
    yield takeEvery(types.PATCH_WIDGET_CONFIG, patchWidgetConfigToUser);
  }

function* patchWidgetConfigToUser({payload}) {
    if (payload && Object.keys(payload)?.length > 0) {
        const session = yield select(activeSession);
        const currentSession = session.activeSession;
        const userResp = yield call(patchAccountDetails, {activeSession: currentSession, body: payload});
        sessionStorage.setItem("accountDetails", JSON.stringify(userResp));
        yield put(updateWidgetConfig(userResp?.customdata?.widgetconfig));
    }
}

export default WidgetSaga;